import {Injectable} from '@angular/core';
import {AgentData} from '../../../model/agent-page-data';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from "../../../../environments/environment";

@Injectable()
export class AgentPageService {

  constructor(private http: HttpClient) {
  }

  getAgentInfo(agentSuffix): Observable<AgentData> {
    const params = new HttpParams().set('agentSuffix', agentSuffix);
    return this.http.get<AgentData>(environment.serverUrl + '/users/get-info', {params: params});
  }

}
